const BARGAIN_PREFIX = 'BARGAIN:'

const bargainPrefix = (event: string) => BARGAIN_PREFIX + event

export const OFFER_CHANGE = bargainPrefix('OFFER:CHANGE')
